import { useCallback, useEffect, useState } from "react";
import { UserManualViewerButton } from "components/elements/user-manual-viewer/user-manual-viewer-button";
import { BACK_OFFICE_API } from "api/routes/back-office/index";
import { API_SERVICE } from "api/service";
import { CustomBreadcrumb } from "components/elements/custom-breadcrumb/custom-breadcrumb";
import { CustomLoader } from "components/elements/custom-loader/custom-loader";
import { CustomModal } from "components/elements/custom-modal/custom-modal";
import { CustomTable } from "components/elements/custom-table/custom-table";
import ErrorBoundary from "components/elements/error-boundary/error-boundary";
import { Optional } from "components/elements/optional/optional";
import { HELPER } from "utils/helper";
import { CreateTransitAccount } from "./create-transit-account";

export function TransitAccounts() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [transitAccounts, setTransitAccounts] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const tableHeaders = [
    { label: "Account Number", value: "accountNumber" },
    { label: "Account Name", value: "accountName" },
    // { label: "Account Reference", value: "accountReference" },
    { label: "Created At", value: "createdAt", itemCase: "createdAt" },
    { label: "Active", value: "active" },
  ];

  const getTransitAccounts = useCallback(() => {
    const params = HELPER.TO_URL_STRING({
      page: pageNo,
      size: 10,
    });
    setCurrentIndex(0);
    const url = BACK_OFFICE_API.TRANSIT_ACCOUNT.SETTLEMENT_TRANSIT_ACCOUNTS;
    API_SERVICE.MAKE_GET_REQUEST(`${url}/paged?${params}`)
      .then((response) => {
        const data = response?.result;
        // console.log("response", response);
        setTransitAccounts(data?.content);
        // setTransitAccounts(response?.result);
        setTotalItems(data?.totalElements);
        setTotalPages(data?.totalPages);
        setCurrentIndex(1);
        setError(null);
      })
      .catch((error) => {
        setError(HELPER.PROCESS_ERROR(error));
        setCurrentIndex(1);
      });
  }, [pageNo]);

  useEffect(() => {
    getTransitAccounts();
  }, [getTransitAccounts]);

  const openModal = useCallback((index) => {
    setCurrentModalIndex(index);
    setIsModalVisible(true);
  }, []);

  function closeModal(isReload) {
    if (isModalVisible) {
      setIsModalVisible(false);
    }
    if (isReload === true) {
      reload();
    }
  }

  function reload() {
    // setSearch(false);
    setCurrentIndex(0);

    getTransitAccounts();
  }

  const modalContent = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return <CreateTransitAccount closeModal={closeModal} />;
    }
  };

  const transitAccountsView = () => {
    // eslint-disable-next-line default-case
    switch (currentIndex) {
      case 0:
        return (
          <div className="loading-container">
            <CustomLoader loadingText="Loading transit accounts..." />
          </div>
        );
      case 1:
        return (
          <CustomTable
            totalPages={totalPages}
            totalItems={totalItems}
            currentPage={pageNo + 1}
            range={null}
            emptyText="No transit accounts found!"
            search={false}
            reload={reload}
            error={error}
            items={transitAccounts}
            headers={tableHeaders}
            nextPage={() => setPageNo(pageNo + 1)}
            prevPage={() => setPageNo(pageNo - 1)}
            goToFirstPage={() => setPageNo(0)}
            goToLastPage={() => setPageNo(totalPages - 1)}
            goToPage={(pageNo) => setPageNo(pageNo)}
          />
        );
    }
  };

  return (
    <ErrorBoundary>
      <div>
        {/* <Toast ref={toast} /> */}
        <div>
          <CustomModal
            closeModal={closeModal}
            onHide={closeModal}
            visible={isModalVisible}
            modalContent={modalContent}
          />
        </div>
        {/* <div className="page-title p-text-left">Transit Accounts</div> */}
        <div className="page-header">
          <div className="page-title p-text-left">Transit Accounts</div>
          <UserManualViewerButton fileName="settings_transit_account_setup" />
        </div>
        <div className="p-mt-2">
          <CustomBreadcrumb page="Transit Accounts" />
        </div>
        <div className="floating-buttons desktop-scree p-mt-5">
          <div className="p-grid">
            <div className="p-col-7"></div>
            <div className="p-col-5">
              <div className="p-grid">
                <div className="p-col-6"></div>
                <div className="p-col-6">
                  <Optional
                    show={HELPER.HAS_AUTHORITY(
                      "bo_create_settlement_transit_account"
                    )}
                  >
                    <button
                      onClick={() => openModal(0, false)}
                      className="primary-button hide-btn-text"
                    >
                      <i className="pi pi-plus" />
                      <span className="hide-btn-text">
                        {" "}
                        New Transit Account
                      </span>
                    </button>
                  </Optional>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>{transitAccountsView()}</div>
      </div>
    </ErrorBoundary>
  );
}
